import React from 'react';
import { Star, Quote, Globe } from 'lucide-react';

const testimonials = [
  {
    name: "Alison Garcia",
    role: "Mortgage Lender",
    company: "Providence Home Loans",
    location: "United States",
    quote: "The POD team delivered our entire marketing funnel in 5 days. What would have taken us months, they did in less than a week. Absolutely incredible service!",
    rating: 5,
    image: "https://customer-assets.emergentagent.com/job_oneforcelive/artifacts/zn3ampjg_alison%20garcia.jpeg"
  },
  {
    name: "Dennis Hubbard",
    role: "Founder & CEO",
    company: "Credit Firm Inc",
    location: "United States",
    quote: "I've tried several agencies before, but nothing compares to the AI Horse-Powered team. The Co-Op Funds alone saved us over $50,000 in our first year.",
    rating: 5,
    image: "https://customer-assets.emergentagent.com/job_oneforcelive/artifacts/99tjuhjh_dennis%20hubbard.jpeg"
  },
  {
    name: "Jim O'Farrell",
    role: "Owner",
    company: "JNO Roofing",
    location: "United States",
    quote: "From AI chatbots to full CRM setup, they handled everything. Our lead conversion increased by 340% in the first 90 days. Best investment we ever made.",
    rating: 5,
    image: "https://customer-assets.emergentagent.com/job_oneforcelive/artifacts/9k1f72cj_jimmy%20ofarrell.png"
  },
  {
    name: "Dennis Voice",
    role: "HVAC Sales Manager",
    company: "Voice Heating & Cooling",
    location: "United States",
    quote: "As a local service business, I didn't think I could afford this level of marketing. The Co-Op program made it possible. Now I'm booked out 3 months in advance!",
    rating: 5,
    image: "https://customer-assets.emergentagent.com/job_oneforcelive/artifacts/9gwmjbpp_dennis%20voice.png"
  }
];

const Testimonials = () => {
  return (
    <section className="py-16 md:py-24 bg-slate-950 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-emerald-500/30 to-transparent" />
        <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-cyan-500/30 to-transparent" />
        <div className="absolute top-1/4 right-0 w-[400px] h-[400px] bg-emerald-500/5 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 left-0 w-[400px] h-[400px] bg-cyan-500/5 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-emerald-500/10 border border-emerald-500/20 rounded-full px-4 py-2 mb-4">
            <Star className="w-4 h-4 text-emerald-400 fill-amber-400" />
            <span className="text-emerald-400 text-sm font-medium">Real Results from Real Businesses</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
            What Our Clients Say
          </h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto">
            Business owners who activated their POD platform and put the AI Horse-Powered system to work.
          </p>
        </div>

        {/* Testimonials Grid - 2x2 */}
        <div className="grid md:grid-cols-2 gap-6">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-slate-900/80 border border-slate-800 rounded-2xl p-6 hover:border-cyan-500/30 transition-all"
            >
              {/* Header with Photo & Info */}
              <div className="flex items-start gap-4 mb-4">
                <img 
                  src={testimonial.image} 
                  alt={testimonial.name}
                  className="w-14 h-14 rounded-full object-cover border-2 border-slate-700"
                />
                <div className="flex-1">
                  <h4 className="text-white font-bold">{testimonial.name}</h4>
                  <p className="text-slate-400 text-sm">{testimonial.role}</p>
                  <p className="text-cyan-400 text-sm">{testimonial.company}</p>
                </div>
              </div>
              
              {/* Stars */}
              <div className="flex gap-0.5 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 text-emerald-400 fill-amber-400" />
                ))}
              </div>
              
              {/* Quote */}
              <p className="text-slate-300 leading-relaxed mb-4">
                &quot;{testimonial.quote}&quot;
              </p>
              
              {/* Location */}
              <div className="flex items-center gap-2 text-slate-500 text-sm">
                <Globe className="w-4 h-4" />
                <span>{testimonial.location}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
